import { Box, MenuItem, Select, Typography } from '@mui/material';
import {
  ProductOption,
  ProductOptionValue,
} from '../../interfaces/Product/ProductOption';
import { sharedColors } from '../../utils/Style';
import { useLocalizedText } from '../../hooks/useLocalizedText';

export type OptionDropdownProps = {
  option: ProductOption;
  value?: ProductOptionValue;
  onChange: (value?: ProductOptionValue) => void;
};

export const OptionDropdown = ({
  option,
  value,
  onChange,
}: OptionDropdownProps) => {
  const t = useLocalizedText();

  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, width: '100%' }}
    >
      <Typography
        sx={{ fontSize: '15px', fontWeight: 600, color: sharedColors.gray7 }}
      >
        {option.name}
      </Typography>

      <Select
        size='small'
        value={value?.id ?? null}
        required
        fullWidth
        onChange={(e) =>
          onChange(option.values.find((x) => x.id === e.target.value))
        }
        sx={{
          maxWidth: 300,
        }}
      >
        {option.values.map((val) => (
          <MenuItem key={val.id} value={val.id}>
            {val.label} {val.stock ? '' : `- ${t('product.out_of_stock')}`}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};
